import { addMonths, startOfMonth } from "date-fns";

export const getMinGoalDueDate = (now: Date = new Date()): Date =>
	startOfMonth(addMonths(now, 1));
